import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_HOST;


export const getService = async ({ limit = 10, page = 1 }) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/service`, {
    params: { limit, page },
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const addService = async (data) => {
  const token = localStorage.getItem("access_token");

  const response = await axios.post(
    `${API_BASE_URL}/service/add`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};



export const updateService = async (payload) => {
  const token = localStorage.getItem("access_token");

  return axios.post(
    `${API_BASE_URL}/service/update`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getServiceById = async (id) => {
  const token = localStorage.getItem("access_token");

  try {
    const response = await axios.get(`${API_BASE_URL}/service/show/${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const deleteServiceList = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/service/delete/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};


